module.exports = __webpack_public_path__ + "static/media/diningMM2.26b34c21.jpg";